<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="localVisible"
      width="70%"
      :before-close="handleClose"
      class="alipay-dialog"
    >
      <el-form :rules="rules" ref="form" size="small" :model="addForm" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="规格名称">
              <el-input disabled v-model="addForm.attr_name" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="新增规格值">
              <el-input v-model="newSpecValue" placeholder="请输入新规格值" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="addSpecValue">添加</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-table :data="addForm.val" border stripe>
              <el-table-column label="规格值" prop="name"></el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button type="text" class="delete-btn" @click="delVal(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="onSubmit">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'eAttrVal',
  props: {
    visible: Boolean,
    formData: Object,
    title: String,
    closeForm: Function,
  },
  data() {
    return {
      localVisible: false,
      addForm: {
        attr_id: null,
        attr_name: '',
        val: []
      },
      newSpecValue: '',
      rules: {}
    };
  },
  watch: {
    visible(val) {
      this.localVisible = val;
      if (val && this.formData) {
        // 初始化数据
        this.addForm = {
          attr_id: this.formData.attr_id,
          attr_name: this.formData.attr_name,
          val: (this.formData.val || []).map(item => ({ ...item })) // 深拷贝
        };
        this.newSpecValue = '';
      }
    }
  },
  methods: {
    // 添加新规格值
    addSpecValue() {
      const val = this.newSpecValue.trim();
      if (!val) {
        this.$message.warning('请输入规格值');
        return;
      }
      if (this.addForm.val.some(item => item.name === val)) {
        this.$message.warning('规格值已存在');
        return;
      }
      this.addForm.val.push({ id: null, name: val });
      this.newSpecValue = '';
    },
    // 删除规格值
    delVal(row) {
      if (row.id) {
        this.$confirm('此操作将删除该规格值, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            id: row.id,
          };
          this.$axios.goodsAttributesValDel(param).then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              const index = this.addForm.val.findIndex(item => item.id === row.id);
              if (index !== -1) this.addForm.val.splice(index, 1);
            } else {
              this.$message.error(res.msg);
            }
          }).catch(err => console.error(err));
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      } else {
        // 新添加未保存的记录直接前端移除
        const index = this.addForm.val.findIndex(item => item.name === row.name);
        if (index !== -1) this.addForm.val.splice(index, 1);
      }
    },
    handleClose() {
      this.closeForm();
    },
    onSubmit() {
      if (this.addForm.val.length === 0) {
        this.$message.warning('请至少添加一个规格值');
        return;
      }
      const params = {
        attr_id: this.addForm.attr_id,
        attr_name: this.addForm.attr_name,
        val: this.addForm.val,
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        shop_id: sessionStorage.getItem('shop_id')
      };
      this.$axios.goodsAttributesMoreValSave(params).then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功');
          this.closeForm();
        } else {
          this.$message.error(res.msg || '保存失败');
        }
      }).catch(error => {
        this.$message.error('保存错误');
        console.error(error);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* 支付宝风格弹窗 */
::v-deep .el-dialog {
  border-radius: 20px;
  overflow: hidden;
  .el-dialog__header {
    background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
    padding: 16px 24px;
    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
    }
  }
  .el-dialog__body {
    padding: 24px;
  }
  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid #f0f0f0;
  }
  .el-button {
    border-radius: 24px;
    padding: 8px 20px;
  }
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}
.delete-btn {
  color: #fa6b6b;
  &:hover {
    color: #ff4d4f;
  }
}
</style>